import React, { useState, useEffect } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Container, Row, Col, Table, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function PurchaseLCRegister() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);

    useEffect(() => {
        axios.get(`${window.backendUrl}/purchase_lc_register`)
            .then(res => setRows(res.data.data || []))
            .catch(err => console.error(err));
    }, []);

    return (
        <>
            <NavigationBar />
            <Container fluid style={{ marginTop: 20 }}>
                <Row className="mb-3"><Col><h3>LC &amp; EDF Register</h3><p className="text-muted">Fills in as import purchases pass through the bank stage — the Bank &amp; LC workflow itself is coming in the next phase of this module.</p></Col></Row>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr><th>PO No.</th><th>Vendor</th><th>LC No.</th><th>Status</th><th>Issue date</th><th>Expiry</th><th>Amount</th></tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 ? (
                            <tr><td colSpan={7} className="text-center text-muted" style={{ padding: 20 }}>No LCs recorded yet.</td></tr>
                        ) : rows.map(r => (
                            <tr key={r.LCID}>
                                <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/purchase-file/${r.PurchaseID}`)}>{r.PONo}</td>
                                <td>{r.VendorName}</td>
                                <td>{r.LCNo || '-'}</td>
                                <td><Badge bg="info">{r.Status}</Badge></td>
                                <td>{r.IssueDate ? String(r.IssueDate).slice(0, 10) : '-'}</td>
                                <td>{r.ExpiryDate ? String(r.ExpiryDate).slice(0, 10) : '-'}</td>
                                <td>{r.Currency} {r.Amount ? Number(r.Amount).toLocaleString() : '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </>
    );
}

export default PurchaseLCRegister;
